export default {
  common: require("./ja/common"),
  validations: require("./ja/validations"),
  bank: require("./ja/bank"),
  login: require("./ja/login"),
  oauth_authorize: require("./ja/oauth_authorize"),
  sidebar: require("./ja/sidebar"),
  application: require("./ja/application"),
  csv: require("./ja/csv"),
  transaction: require("./ja/transaction"),
  account: require("./ja/account"),
  tag: require("./ja/tag"),
  header: require("./ja/header"),
  screen: require("./ja/screen"),
  support: require("./ja/support"),
  terms: require("./ja/terms"),
  paging: require("./ja/paging")
}
